import { useMemo, useSyncExternalStore } from 'react'

const getServerSnapshot = () => {
  return false
}

export const useMediaQuery = (query: string) => {
  const [getSnapshot, subscribe] = useMemo(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
      return [
        () => false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => () => {},
      ]
    }
    const mediaQueryList = window.matchMedia(query)
    return [
      () => mediaQueryList.matches,
      (onChange: () => void) => {
        mediaQueryList.addEventListener('change', onChange)
        return () => {
          mediaQueryList.removeEventListener('change', onChange)
        }
      },
    ]
  }, [query])

  const match = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  )

  return match
}
